/**
 * Bug Report System Setup
 * Initializes user action tracking (clicks, navigation, form submissions)
 * for inclusion in bug reports.
 */

import { initializeUserActionTracking } from "./activityTracker";

export function setupBugReportSystem() {
  if (typeof document !== "undefined") {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        initializeUserActionTracking();
        console.info("[Bug Report] User action tracking initialized");
      });
    } else {
      initializeUserActionTracking();
      console.info("[Bug Report] User action tracking initialized");
    }
  }

  console.info("[Bug Report] System initialized");
}

export { activityTracker } from "./activityTracker";
